import React from 'react';
import { Tooltip } from '@fx-ui/fine-design';
import classNames from 'classnames';
import { TRACKER } from '~/constants';
import { insertURLQuery, redirect, tracker } from '~/utils';
import Intl from '@fx-ui/intl';
import { IconFont } from '~/components';
import { corpUserStore } from '~/models';
import { getCorpContactUrl } from '@fx-ui/platform-sdk';

interface IContactsProps {
    onlyIcon?: boolean;
    url?: string;
}

const Contacts: React.FC<IContactsProps> = (props: IContactsProps) => {
    const { onlyIcon, url } = props;

    const handleContactClick = () => {
        tracker(TRACKER.NAV_TOOLBAR_CLICK, {
            area: '',
            type: 'contacts'
        });
        tracker(TRACKER.CONTACTS_VIEW_FROM_DASHBOARD);
        redirect(
            url ||
                insertURLQuery(getCorpContactUrl(corpUserStore.tenantId), [
                    {
                        key: 'referer_uri',
                        value: encodeURIComponent(window.location.href)
                    }
                ])
        );
    };

    const wrapTooltip = (contactEl: React.ReactElement) => {
        if (onlyIcon) {
            return (
                <Tooltip content={Intl.get('contacts')} effect="dark" placement="bottom">
                    {contactEl}
                </Tooltip>
            );
        }
        return contactEl;
    };

    return wrapTooltip(
        <div
            className={classNames('fx-nav-contact', { 'has-text': !onlyIcon })}
            onClick={handleContactClick}
        >
            <IconFont type="contact" />
            {!onlyIcon && <span>{Intl.get('contacts')}</span>}
        </div>
    );
};

export default Contacts;
